import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { Publication } from '@shared/models/records/publication.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-publication-pdf-result-card',
  templateUrl: './publication-pdf-result-card.component.html',
  styleUrls: ['./publication-pdf-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PublicationPdfResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new Publication(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get virtual_path() {
        return this.record.path.virtual;
    }

    get file_name() {
        return this.record.file.filename;
    }

    get title() {
        return this.record.meta.title;
    }

    get author(): any[] {
        return this.record.meta.author;
    }

    get subject(): any[] {
        return this.record.meta.subject;
    }

    get file_size(): any[] {
        return this.record.file.filesize;
    }
    
    get synopsis(): any[] {
        return this.record.meta.synopsis;
    }

    get file_path() {
        return environment.azure_blob_storage + DatabaseIndexNameType.publication + this.virtual_path;
    }
}